import React from 'react';
import {useTranslation} from "react-i18next";

export const LoadingScreen = ({message}) => {

    const {t} = useTranslation();
    if (!message)
        message = t('loading.message');

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center">
            <div
                className="w-12 h-12 border-4 border-brand-dark border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-gray-400 text-sm font-bold tracking-widest animate-pulse uppercase">
                {message}
            </p>
        </div>
    );
};